<template>
  <div v-if="pendingCount > 0" class="card clinic-invites-notice">
    <div class="clinic-invites-notice__text">
      <span class="clinic-invites-notice__title">{{ title }}</span>
      <span class="clinic-invites-notice__sub">
        Aceite ou recuse no menu Clínicas.
      </span>
    </div>
    <router-link
      :to="{ name: 'DoctorClinics' }"
      class="btn btn--primary btn--sm"
    >
      Ver convites
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Aviso do dashboard do médico quando há convite de clínica pendente.
export default {
  name: "ClinicInvitesNotice",
  computed: {
    ...mapGetters("clinicInvitations", ["pendingCount"]),
    title() {
      const noun = this.pendingCount === 1 ? "convite" : "convites";
      return `Você tem ${this.pendingCount} ${noun} de clínica`;
    }
  }
};
</script>

<style lang="scss" scoped>
.clinic-invites-notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4) var(--space-5);
  border-left: 3px solid var(--color-primary);

  &__text {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__title {
    font-size: var(--font-size-md);
    font-weight: var(--fw-bold);
    color: var(--color-gray-900);
  }

  &__sub {
    font-size: var(--font-size-sm);
    color: var(--color-gray-500);
  }
}

@media (max-width: 860px) {
  .clinic-invites-notice {
    flex-direction: column;
    align-items: stretch;

    .btn {
      text-align: center;
    }
  }
}
</style>
